import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const ModalWrapper = styled.div`
  .modal-root {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: 50;
    @media only screen and (max-width: 1440px) {
      //overflow: scroll;
    }
    
    .modal-close {
      position: absolute;
      width: 32px;
      height: 32px;
      padding: 0;
      background-color: ${themeGet('colors.body.light')};
      color: ${themeGet('colors.body.text')};
      border-radius: ${themeGet('radii.base')};
      right: 80px;
      top: 20px;
      border: none;
      outline: none;
      line-height: 0;
    }
  }

  .modal-motion {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    
    .modal-full {
      position: relative;
      width: auto;
      height: auto;
      max-width: 90vw;
      max-height: 90vh;
      display: flex;
      flex-direction: column;

      &.modal-term {
        max-height: 742px;
        max-width: 658px;
      }
      
      &.modal-top {
        align-self: flex-start;
        margin-top: 64px;
        max-height: calc(90vh - 64px);

        @media only screen and (max-width: 1440px) {
          margin-top: 40px;
          max-height: calc(90vh - 40px);
        }
        
        @media only screen and (min-height: 700px) {
          max-height: 690px;
        }
      }

      .modal-overflow {
        width: 100%;
        height: auto;
        max-height: inherit;
        box-shadow: ${themeGet('shadows.section')};
        overflow-y: auto;
        border-radius: ${themeGet('radii.base')};
        
        @media only screen and (max-width: 1440px) {
          overflow-y: auto;
        }
      }
    }
  }
`;
